import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'empty',
  head() {
    return {
      title: 'Extra Debit Card Members Area - EXTRA'
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('plaid_oauth_state_id');
    const uri = window.location.search;
    if (id || uri) {
      window.localStorage.setItem('plaid_oauth_uri', uri);
    }
    window.extra_data_ul.log([{
      kingdom: 'view',
      phylum: 'page',
      class: 'members_area',
      subclass: 'oauth:plaid',
      family: id || uri ? 'success' : 'fail',
      genus: window.location.search
    }]);
    const returnPath = window.localStorage.getItem('plaid_oauth_return_path') || '/members/card';
    window.localStorage.removeItem('plaid_oauth_return_path');
    this.$router.push(returnPath);
  }
};